var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#363a4a",
    width: 9.332,
    height: 10.672,
    viewBox: "0 0 9.332 10.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.165,3.7l1.594-1.6L304.666,0l-1.594,1.6Z",
    transform: "translate(-297.427 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.655,325.291l-.491.493v2.1h2.095l.49-.492Z",
    transform: "translate(-32.164 -318.513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6,112.214l3.925-3.943-2.093-2.1-3.925,3.943Z",
    transform: "translate(-84.396 -103.957)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.164,482.193H41.5v.625H32.164Z",
    transform: "translate(-32.164 -482.193)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.286 8.748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.864,419.821h5.046v.625h-5.046Z",
    transform: "translate(-237.864 -419.821)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/editProfile.26719a2e6492a5ec4aa1886298213661.svg";
export { ForwardRef as ReactComponent };